import { Mtds } from 'prove-common'

type Props = {
  hasData: boolean
  isFetching: boolean
  isError: boolean
  refetch: () => Promise<unknown>
}

export function ReferenceQueryStatus({
  hasData,
  isFetching,
  isError,
  refetch
}: Props) {
  return (
    <>
      {isFetching && (
        <p role='status'>
          {hasData
            ? 'Oppdaterer listen. Viser sist hentede data.'
            : 'Laster oppføringer …'}
        </p>
      )}
      {isError && (
        <Mtds.Alert as='div' role='alert' data-color='danger'>
          <Mtds.Grid>
            <p>
              {hasData
                ? 'Kunne ikke oppdatere listen. Viser sist hentede data, som kan være utdaterte.'
                : 'Kunne ikke hente oppføringene. Prøv igjen.'}
            </p>
            <Mtds.Button
              data-variant='secondary'
              disabled={isFetching}
              aria-busy={isFetching}
              onClick={() => void refetch()}
            >
              Prøv igjen
            </Mtds.Button>
          </Mtds.Grid>
        </Mtds.Alert>
      )}
    </>
  )
}
